import ExternalLink from './external.link'

export default ExternalLink
